module.exports = __webpack_public_path__ + "static/media/socialPiper-post-tablet-en.19aecc2d.png";